/* eslint-disable */
import React, { FunctionComponent, useEffect, useMemo, useRef, useState } from "react";
import Button from "../../components/ui/Button";
import { IAmount } from "./Amount";
import {
  ArrowRight,
  DropdownIcon,
  Editable,
  LockIcon,
  NotEditable,
  TransferIcon,
  UnlockIcon,
} from "../../assets/Icons";
import { UserTransactionDetails } from "../../store/store";
import { useRecoilValue } from "recoil";
import { DebounceInput } from "react-debounce-input";
import ErrorField from "../../components/ui/ErrorField";
import { additionalDocumentsList, formatNumber, getSendMoneyErrorMessage, receivingCountryData } from "../../utils";
import { useRecoilState } from "recoil";
import { declarationDefault, openLoanModal, selectVendor, transactionDetails, vendorCodes } from "../../store";
import { Dialog, TextField } from "@material-ui/core";
import Dropdown from "../../components/ui/Dropdown";
import { getVendorCode } from "../../services/purposeCode";
import { Autocomplete } from "@material-ui/lab";
import DownloadIcon from "../../assets/Icons/DownloadIcon";
import { Axios } from "../../services/axios";
import download from "downloadjs";
import { ToastContainer, toast } from "react-toastify";
import VendorDropdown from "./VendorDropDown";
import Select from "react-select";
import { has } from "underscore";
import Skeleton from "react-loading-skeleton";


export const PaymentOverview: FunctionComponent<IAmount.PaymentOverviewProps> = ({
  sendingAmount,
  setSendingAmount,
  recievingAmount,
  setReceivingAmount,
  rate,
  setRate,
  destCurrency,
  setIsModalOpen,
  base_currency,
  purposeCode,
  proceedClick,
  purposeValue,
  errorMessage,
  // sendTransferSummary,
  // rateTransferSummary,
  // receiveTransferSummary,
  setIsPurposeModalOpen,
  isErrorPresent,
  setReceiveLocked,
  receiveLocked,
  setErrorMessage,
  cardRates,
  firstTimeLoanPopup,
  setFirstTimeLoanPopup,
  loading,
  tcs,
  setOnChangeHandleType,
  setDestCurrency
}) => {
  const transactionData: UserTransactionDetails = useRecoilValue(transactionDetails);
  const [editable, setEditable] = useState<boolean>(true);
  const [recieveDisabled, setReceiveDisabled] = useState<boolean>(false);
  const [openModal, setOpenModal] = useRecoilState(openLoanModal);
  const [vendorCodeList, setVendorCodeList] = useRecoilState(vendorCodes);
  const [vendorCode, setVendorCode] = useRecoilState(selectVendor);
  const [data, setData] = useState<any>([]);
  const [inputValue, setInputValue] = useState("");
  const [formattedSendAmount, setFormattedSendAmount] = useState("");
  const [formattedReceiveAmount, setFormattedReceiveAmount] = useState("");
  const [vendorData, setVendorData] = useState("");

  const hasShownToast = useRef<string | null>(null);

  const handleLockClick = () => {
    setReceiveLocked(!receiveLocked);
  };
  const handleDataFromChild = (data: string) => {
    setVendorData(data);
  };

  useEffect(() => {
    if (receiveLocked === true) {
      setReceiveDisabled(true);
    } else if (receiveLocked === false) {
      setReceiveDisabled(false);
    }
    handleVendorCodes();
  }, [receiveLocked]);

  const validateRate = (e: React.ChangeEvent<HTMLInputElement>) => {
    let { value } = e.target;

    if (value === null || value === undefined || value === "null") {
      value = "";
      toast.error("Please enter a valid rate");
    }

    if (value === "") {
      setRate("");
      toast.error("Please enter a valid rate");
      return;
    }

    const numericValue = Number(value);
    if (isNaN(numericValue) || numericValue < 0) {
      toast.error("Please enter a valid rate");
      return;
    }

    setRate(numericValue);
  };


  const handleVendorCodes = () => {
    getVendorCode()
      .then((res: any) => {
        setData(res?.data);
        // setDefaultVendorCode(res?.data.filter((data: any)=>data?.userId === userId));
        // console.log("Vendor Codes", res?.data);
      })
      .catch((error) => {
        console.error("ERROR", error);
      });
  };

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (!errorMessage) {
        hasShownToast.current = null;
        return;
      }

      if (hasShownToast.current === errorMessage) return;

      const cleanedAmount = Number(String(sendingAmount).replace(/,/g, ""));
      const cleanedReceiveAmount = Number(String(recievingAmount).replace(/,/g, ""));
      const error = errorMessage.toLowerCase();

      if (
        (error.includes("internal server error")) &&
        (cleanedReceiveAmount !== undefined && (cleanedReceiveAmount < 55 || isNaN(cleanedReceiveAmount)))
      ) {
        toast.error("Recipient Amount should be greater than or equal to 100");
      } else if (
        (error.includes("internal server error")) &&
        (cleanedAmount !== undefined && (cleanedAmount < 5000 || isNaN(cleanedAmount)))
      ) {
        toast.error("INR Amount should be greater than or equal to 5000");
      } else {
        toast.error(errorMessage);
      }

      hasShownToast.current = errorMessage;
    }, 1000);

    return () => clearTimeout(delayDebounce);
  }, [errorMessage, sendingAmount, recievingAmount]);


  const handleDownloadQuoteClick = async () => {
    let vendor_code;
    data
      .filter(
        (item: { displayName: string | null; userId: string; vendorCode: string }) =>
          item.vendorCode === vendorCode?.vendorCode,
      )
      .map((item: { displayName: string | null; userId: string; vendorCode: string }) => {
        vendor_code = item.userId;
      });


    const purpose = additionalDocumentsList.find((item) => item.name === purposeValue)?.code;
    const userId = localStorage.getItem("userKey") || "{}";
    const Money_you_send = sendingAmount.toString();
    const Money_they_receive = recievingAmount.toString();
    const Exchange_rate = rate.toString();

    const totalTaxes_charges =
      transactionData.total_tax +
      transactionData.nostro_charges +
      transactionData.nostro_charges_new +
      transactionData.hop_fees +
      transactionData.tcs;
    const totalFees = totalTaxes_charges.toString();
    const youPay = parseFloat(Money_you_send) + parseFloat(totalFees);

    if (!sendingAmount || !recievingAmount || !rate || !vendor_code || !purpose) {
      toast.error("TO DOWNLOAD QUOTE, FILL VENDORCODE AND PURPOSECODE");
      return;
    }

    const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
    try {
      const response = await Axios.get(`remit/user/${userId}/quote`, {
        params: {
          transVendorKey: vendorCode?.userId,
          destinationCurrency: destCurrency,
          conversionRate: Exchange_rate,
          recipientReceive: Money_they_receive,
          taxes: transactionData.total_tax,
          totalPay: youPay,
          purposeCode: purpose,
          userSend: sendingAmount,
          tcs: transactionData.tcs,
          bankFee: transactionData.nostro_charges,
          nostro: transactionData.nostro_charges_new,
          vendorFee: transactionData.hop_fees,
        },
        headers: {
          Authorization: `${currentUser.idToken}`,
        },
        responseType: "blob",
      });
      if (response?.status === 200) {
        const content = response.headers["content-type"];

        download(response.data, "Quote.pdf", content);
      } else {
        if (
          response.data &&
          response.data.error &&
          response.data.error.code === 2000 &&
          response.data.error.type === "User Send cannot be less than 5000"
        ) {
          console.log("User Send cannot be less than 5000");
        }
        toast.error(`${response?.data?.error?.type}`);
      }
    } catch (error: any) {
      // Check if the error response contains the expected error structure
      if (error.data && error.data.error) {
        toast.error(`${error.data.error.type}`);
      } else {
        // General error handling
        toast.error("An unexpected error occurred.");
      }
    }
  };

  const showCardRate = cardRates?.find((cardRate) => cardRate?.currency === destCurrency);
  const cardRateToShow =
    purposeValue === "Family Maintenance" || purposeValue === "Personal Gift or Donation"
      ? showCardRate?.cardRateAd1
      : showCardRate?.cardRate;

  useEffect(() => {
    const formatted = formatNumber(sendingAmount);
    setFormattedSendAmount(formatted ?? "");
  }, [sendingAmount]);

  useEffect(() => {
    const formatted: any = formatNumber(recievingAmount);
    if (!isNaN(Number(formatted?.replace(/,/g, "")))) {
      setFormattedReceiveAmount(formatted);
    }
  }, [recievingAmount]);


  return (
    <div id="paymentOverview" className="-ml-[2%]">
      <div className="flex flex-col text-[30px] font-semibold font-ssp mb-5">
        Amount
        {/* <span className="text-[20px]">Enter the amount of the transaction.</span> */}
      </div>
      <div className="px-5 py-6 space-y-5 border border-gray-200 rounded-md w-[560px] h-[620px] shadow-xl">
        <div id="youSend" className="flex flex-col justify-center">
          <span className="font-semibold text-[19px]">You Send</span>
          <div className="flex items-center mr-5 ">
            {/* {!formattedSendAmount || loading ?(
              <Skeleton width={350} height={65} />   // loader if no value
            ) : ( */}
            <DebounceInput
              minLength={2}
              className="rounded-md p-[3.4%] bg-blue-100 text-lg outline-none w-[420px]"
              name="sendingAmount"
              type="text"
              maxLength={15}
              value={formattedSendAmount}
              debounceTimeout={0}
              onChange={(e: any) => {
                const newAmount = e.target.value.replace(/,/g, "");
                setSendingAmount(newAmount);
                setOpenModal(purposeCode === "S0305"); //&& e.target.value >= 700000
                // if (receiveLocked) {
                //   receiveTransferSummary(recievingAmount, false);
                // } else {
                //   sendTransferSummary(newAmount, destCurrency, false);
                // }
                setOnChangeHandleType("send");
              }}
              disabled={receiveLocked}
            />
            {/* ) } */}
            <div className="flex py-[17px] w-[155px] space-x-4 border rounded-md cursor-pointer">
              <img
                src={`/images/png/INR.png`}
                alt="country-image"
                className="rounded-[200px] w-7 h-7 ml-5"
              />
              <span className="bg-white text-[19px]">{base_currency}</span>
            </div>
          </div>
          {/* <ErrorField
            errorMessage={getSendMoneyErrorMessage(destCurrency, sendingAmount)}
            errorClassname="relative"
          /> */}
          {/* <span className="font-semibold text-red-500 text-[13px] animate-fade">
              {errorMessage && errorMessage}
            </span> */}
        </div>
        <div id="theyRecieve" className="flex flex-col justify-center">
          <span className="text-[19px] font-semibold">They Receive</span>
          <div className="flex mr-5 ">
            {/* {!formattedReceiveAmount || loading ? (
              <Skeleton width={350} height={65} />   // loader if no value
            ) : ( */}
            <DebounceInput
              minLength={2}
              className="w-[400px] rounded-l-md p-[3.4%] bg-blue-100 text-lg outline-none"
              name="recievingAmount"
              type="text"
              value={formattedReceiveAmount}  // always a string
              debounceTimeout={0}
              disabled={recieveDisabled}
              onChange={(e: any) => {
                const newAmount = e.target.value.replace(/,/g, "");
                setReceivingAmount(newAmount);
                setOpenModal(purposeCode === "S0305");
                setOnChangeHandleType("receive");
              }}
              min={55}
            />
            {/* )} */}
            <div
              id="lockIcon"
              className="flex items-center justify-center pr-2 bg-blue-100 cursor-pointer"
              onClick={handleLockClick}
            >
              {receiveLocked ? <LockIcon /> : <UnlockIcon />}
            </div>
            {/* <div
              onClick={() => setIsModalOpen("recieve")}
              className="flex py-[17px] w-[155px] space-x-3 border rounded-md cursor-pointer"
            >
              <img
                src={`/images/png/${destCurrency}.png`}
                alt="receiving-country-image"
                className="rounded-[200px] w-7 h-7 ml-3"
              />
              <span className="bg-white text-[19px] space-x-2 flex items-center">
                <span className="-ml-2">{destCurrency}</span>
                <DropdownIcon />
              </span>
            </div> */}
            <Select<{ value: any; label: any }>
              defaultValue={
                receivingCountryData?.[0]
                  ? {
                    label: receivingCountryData[0].countryName,
                    value: receivingCountryData[0].currencyName,
                  }
                  : undefined
              }
              options={receivingCountryData.map((c) => ({
                label: c?.countryName,
                value: c?.currencyName,
              }))}
              value={
                receivingCountryData
                  .map((c) => ({
                    label: c?.countryName,
                    value: c?.currencyName,
                  }))
                  .find((option) => option.value === destCurrency) || null
              }
              onChange={(selectedOption) => {
                setDestCurrency(selectedOption?.value);
              }}
              styles={{
                control: (base) => ({
                  ...base,
                  backgroundColor: "#fff",
                  paddingInline: "8px",
                  alignSelf: "stretch",
                  color: "#b5b5bd",
                  fontFamily: "Inter",
                  fontSize: "20px",
                  fontWeight: 500,
                  fontStyle: "normal",
                  height: "100%",
                  width: "130px",
                  borderColor: "##e5e7eb",
                  boxShadow: "none",
                  borderRadius: "none",
                  borderTopRightRadius: "8px",
                  borderBottomRightRadius: "8px",
                  cursor: "pointer",
                  outline: "none",
                  ":hover": {
                    borderColor: "#e5e7eb",
                  },
                  padding: "0 2px"
                }),
                indicatorSeparator: () => ({ display: "none" }),
                valueContainer: (base) => ({ ...base, padding: 0, margin: 0, paddingLeft: "15%" }),
                input: (base) => ({ ...base, margin: 0, padding: 0 }),
                placeholder: (base) => ({ ...base, margin: 0, padding: 0 }),
                menu: (base) => ({
                  ...base,
                  zIndex: 9999,
                  fontFamily: "Inter",
                  fontSize: "14px",
                }),
                option: (base, { isFocused }) => ({
                  ...base,
                  backgroundColor: isFocused ? "#f0f0f0" : "#fff",
                  color: "#425466",
                  padding: "10px 18px",
                  cursor: "pointer",
                }),
                singleValue: (base) => ({ ...base, margin: 0, color: "#425466" }),
                dropdownIndicator: (base) => ({
                  ...base,
                  padding: "0px",
                  paddingRight: "1px"
                }),
              }}
              components={{ IndicatorSeparator: () => null }}
              isSearchable={true}
              formatOptionLabel={(option) => (
                <div style={{ display: "flex", alignItems: "center", gap: "14px", maxWidth: "100%" }} id={option.value} key={option.value}>
                  <img
                    src={`/images/png/${option.value}.png`}
                    alt={option.label}
                    width={24}
                    height={24}
                    className="rounded-[100px] w-6 h-6"
                  />
                  <div>
                    <div style={{ fontSize: "18px", color: "#000" }}>{option?.value}</div>
                  </div>
                </div>
              )}
            />
          </div>
        </div>
        {/* {receiveLocked &&
            <span className="text-red-200 ml-[10px]">
              
            </span>
         } */}
        <div
          id="purposeCode"
          className="flex flex-col items-start justify-center animate-ping"
        >
          <span className="text-[19px] font-semibold">Purpose Code</span>
          <div
            onClick={() => {
              setIsPurposeModalOpen(true);
              // if (
              //   purposeValue === "Family Maintenance" ||
              //   purposeValue === "Personal Gift or Donation"
              // ) {
              //   setFirstTimeLoanPopup(true);
              //   setIsModalOpen("loan");
              // } else {
              //   setFirstTimeLoanPopup(false);
              // }
            }}
            className="flex py-[17px] w-[370px] font-semibold bg-blue-100
             items-center justify-between border rounded-md cursor-pointer"
          >
            <span className="px-5 font-normal">
              {purposeValue ? purposeValue : "Select Purpose"}
            </span>
            <div className="mr-5 purposeCode-dropdown-icon">
              <DropdownIcon />
            </div>
          </div>
          {purposeValue?.toLowerCase()?.includes("family") || purposeValue?.toLowerCase()?.includes("donation") ?
            <span className="text-red-200 ml-[1px] text-wrap max-w-[370px]">
              User may receive the lesser amount due to the beneficiary bank charges.
            </span> : null}
        </div>
        <div id="Enter Rate" className="flex flex-col">
          <p className="text-[19px] font-semibold">Exchange Rate{" "}
            <span className="font-normal text-[16px] text-gray-500">
              {purposeValue && `(Card rate: 1 ${destCurrency} → ${cardRateToShow} INR)`}
            </span>
          </p>
          <div className="flex flex-col mr-5 ">
            {/* <div className="w-[120px] flex space-x-3 items-center mb-2">
                <span className="font-semibold text-[18px]">{destCurrency}</span>
                <TransferIcon />
                <ArrowRight/>
                <span className="font-semibold text-[18px]">INR</span>
              </div> */}
            <div className={`flex items-center w-[370px] justify-between bg-blue-100 rounded-md ${!purposeCode ? "opacity-15" : ""}`}>
              {/* {!rate || loading ?(
              <Skeleton width={300} height={55} />   // loader if no value
            ) : ( */}
              <DebounceInput
                minLength={2}
                className="w-full rounded-md p-[3.4%] bg-blue-100 text-lg outline-none"
                name="recievingAmount"
                type="number"
                value={rate}
                debounceTimeout={1000}
                onChange={validateRate}
                onInput={(e: any) => {
                  if (e.target.value === "") setRate("");
                }}
                fullWidth
                inputClasses="text-[20px] bg-blue-100"
                disabled={!purposeCode}
              />

              {/* )} */}
              {/* <div onClick={() => setEditable(!editable)} className={`flex items-center justify-center pr-6 bg-blue-100 cursor-pointer`}>
                {editable === true ? <LockIcon /> : <UnlockIcon />}
              </div> */}
            </div>
            {/* {purposeValue && (
              <span className="font-semibold pt-0.5">
                Card rate for {`${destCurrency} - ${cardRateToShow}`}
              </span>
            )} */}
            {!purposeCode &&
              <span className="font-semibold text-red-500 text-[13px] animate-fade">
                Please select the Purpose Code  to edit the exchange rate
              </span>}
          </div>
        </div>
        <div id="Vendor Code" className="flex flex-col">
          <span className="text-[19px] font-semibold">Vendor Name/Code</span>
          <VendorDropdown onVendorChange={handleDataFromChild} />
        </div>
      </div>
      {/* <div id="submit" className="flex gap-5 justify-center mb-0">
        <div id="download quote" className={`flex items-center justify-center bg-white  py-4 mt-6 ml-5 px-6 hover:scale-105 transition-all text-blue font-roboto text-base font-bold rounded border border-blue-500 ${!purposeCode ? "cursor-not-allowed opacity-15": "cursor-pointer opacity-100"}`} onClick={handleDownloadQuoteClick}>
        <span className="font-medium text-[18px]"> Download quote</span>
            <div className="justify-center ">
          </div>
      </div>
        <Button
          bgColor={
            isErrorPresent ||
              getSendMoneyErrorMessage(destCurrency, sendingAmount) !== "" ||
              purposeCode === "" ||
              purposeValue === "" ||
              !vendorCode ||
              (typeof vendorCode === "object" && Object.keys(vendorCode).length === 0) ||
              vendorCode.displayName === "" ||
              loading
              ? "bg-gray-300"
              : "bg-primary-1050"
          }
          fontStyle={{
            fontFamily: "font-roboto",
            fontSize: "text-base",
            fontWeight: "font-bold",
            fontColor: "text-white",
          }}
          borderStyle={{
            borderRadius: "rounded",
          }}
          onClickHandler={proceedClick}
          className={"flex justify-center py-4 mt-6 ml-5 px-14 hover:scale-105 transition-all"}
          disabled={
            isErrorPresent ||
            getSendMoneyErrorMessage(destCurrency, sendingAmount) !== "" ||
            purposeCode === "" ||
            purposeValue === "" ||
            !vendorCode ||
            (typeof vendorCode === "object" && Object.keys(vendorCode).length === 0) ||
            vendorCode.displayName === "" ||
            loading
          }
        >
          Proceed
        </Button>
      </div> */}

    </div>
  );
};
